<template>
    <span class="mission-status-badge" :class="[badgeClass, sizeClass]">
        <InfoDisplay :color="this.color" :icon="'circle'" />
        <span :class="textColor" class="mission-status-text">
            {{ this.text }}
        </span>
    </span>
</template>

<script>
import InfoDisplay from '@/components/display/InfoDisplay.vue'

export default {
    props: {
        status: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            default: 'md'
        }
    },
    components: {
        InfoDisplay
    },
    computed: {
        sizeClass: function () {
            switch (this.size) {
                case 'sm':
                    return 'mission-status-badge-sm'
                case 'md':
                default:
                    return 'mission-status-badge-md'
            }
        },
        badgeClass: function () {
            switch (this.status) {
                case 'ONGOING':
                    return 'mission-status-badge-success'
                case 'PENDING':
                case 'DRAFT':
                    return 'mission-status-badge-warning'
                case 'FINISHED':
                case 'CANCELED':
                    return 'mission-status-badge-muted'
                default:
                    return 'mission-status-badge-muted'
            }
        },
        color: function () {
            switch (this.status) {
                case 'FINISHED':
                    return 'gray'
                case 'ONGOING':
                    return 'green'
                case 'PENDING':
                    return 'orange'
                case 'DRAFT':
                    return 'orange'
                case 'CANCELED':
                    return 'gray'
                default:
                    return 'gray'
            }
        },
        textColor: function () {
            switch (this.status) {
                case 'FINISHED':
                    return 'text-muted'
                case 'ONGOING':
                    return 'text-success'
                case 'PENDING':
                    return 'text-warning'
                case 'DRAFT':
                    return 'text-warning'
                case 'CANCELED':
                    return 'text-muted'
                default:
                    return 'text-muted'
            }
        },
        text: function () {
            switch (this.status) {
                case 'FINISHED':
                    return 'Terminé'.toUpperCase()
                case 'ONGOING':
                    return 'En cours'.toUpperCase()
                case 'PENDING':
                    return 'En attente'.toUpperCase()
                case 'DRAFT':
                    return 'En attente'.toUpperCase()
                case 'CANCELED':
                    return 'Annulée'.toUpperCase()
                default:
                    return 'No data'.toUpperCase()
            }
        }
    },
}
</script>

<style scoped>
.mission-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    border-radius: 999px;
    line-height: 1;
    white-space: nowrap;
}

.mission-status-badge-sm {
    padding: 0.12rem 0.5rem;
    font-size: 0.72rem;
}

.mission-status-badge-md {
    padding: 0.35rem 0.9rem;
    font-size: 0.95rem;
}

.mission-status-text {
    font-weight: 700;
    letter-spacing: 0.02em;
}

.mission-status-badge-success {
    background: rgba(25, 135, 84, 0.1);
}

.mission-status-badge-warning {
    background: rgba(245, 158, 11, 0.12);
}

.mission-status-badge-muted {
    background: rgba(148, 163, 184, 0.12);
}
</style>